import { Buffer } from 'buffer/';

export function decodeBase64<T>(val: string): T {
  return JSON.parse(Buffer.from(val, 'base64').toString('utf-8')) as T;
}

export function encodeBase64(val: unknown): string {
  return Buffer.from(JSON.stringify(val)).toString('base64');
}
